(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["norden-collection-filter-groups"] && !Shopify.designMode) return;
  try {
    const nordenDiagonalBuckets = [
    { min: 10, max: 19, value: '10-19' },
    { min: 20, max: 29, value: '20-29' },
    { min: 30, max: 39, value: '30-39' },
    { min: 40, max: 49, value: '40-49' },
    { min: 50, max: 59, value: '50-59' },
    { min: 60, max: 69, value: '60-69' },
    { min: 70, max: 79, value: '70-79' },
    { min: 80, max: 89, value: '80-89' },
    { min: 90, max: Number.POSITIVE_INFINITY, value: '90-plus' },
  ];

  class NordenCollectionFilterGroups extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || document;
      this.formComponent = this.closest('facets-form-component');
      this.form = this.closest('form');
      if (!this.form || !this.formComponent) return;
      this.handleChange = this.handleChange.bind(this);
      this.handleInput = this.handleInput.bind(this);
      this.handleAction = this.handleAction.bind(this);
      this.addEventListener('change', this.handleChange);
      this.addEventListener('input', this.handleInput);
      this.section.addEventListener('click', this.handleAction);
      this.renderOptions();
      this.restoreFromURL();
      this.updateWeightTracks();
      this.applyFilters();
      this.observer = new MutationObserver(() => {
        if (!this.form || !this.isConnected) return;
        this.renderOptions();
        this.restoreFromURL();
        this.updateWeightTracks();
        this.applyFilters();
      });
      const grid = this.section.querySelector('[data-testid="product-grid"]');
      if (grid) this.observer.observe(grid, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
      this.removeEventListener('input', this.handleInput);
      this.section.removeEventListener('click', this.handleAction);
      this.observer?.disconnect();
    }

    get cards() {
      const elements = [...this.section.querySelectorAll('.product-grid__item[data-norden-price-min]')];
      const unique = new Map();
      for (const card of elements) unique.set(card.dataset.productId, card);
      return [...unique.values()];
    }

    get products() {
      return this.cards.map((card) => ({
        card,
        id: card.dataset.productId,
        priceMin: Number(card.dataset.nordenPriceMin || 0),
        priceMax: Number(card.dataset.nordenPriceMax || 0),
        tvMin: Number(card.dataset.nordenTvMin || 0),
        tvMax: Number(card.dataset.nordenTvMax || 0),
        weight: Number(card.dataset.nordenWeight || 0),
        types: JSON.parse(card.dataset.nordenTags || '[]')
          .map((value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase())
          .filter((value) => ['articule', 'inclinable', 'fixe'].includes(value)),
        vesa: (card.dataset.nordenVesa || '')
          .split(',')
          .map((value) => value.trim().toLowerCase())
          .filter(Boolean),
      }));
    }

    renderOptions() {
      const products = this.products;
      const separator = this.dataset.rangeSeparator || '–';
      const inch = this.dataset.inch || '″';
      const diagonalOptions = this.querySelector('[data-norden-options="diagonal"]');
      const vesaOptions = this.querySelector('[data-norden-options="vesa"]');
      const typeOptions = this.querySelector('[data-norden-options="type"]');
      if (typeOptions) {
        typeOptions.replaceChildren(
          this.createOption('type', 'articule', this.dataset.typeArticulated),
          this.createOption('type', 'inclinable', this.dataset.typeTilting),
          this.createOption('type', 'fixe', this.dataset.typeFixed)
        );
      }
      if (diagonalOptions) {
        const ranges = nordenDiagonalBuckets.filter((bucket) =>
          products.some((product) => this.inDiagonalBucket(product, bucket))
        );
        diagonalOptions.replaceChildren(
          ...ranges.map((bucket) => {
            const label = Number.isFinite(bucket.max)
              ? `${bucket.min}${inch} ${separator} ${bucket.max}${inch}`
              : `${bucket.min}${inch} ${this.dataset.andMore || 'and +'}`;
            return this.createOption('diagonal', bucket.value, label);
          })
        );
      }
      if (vesaOptions) {
        const values = [...new Set(products.flatMap((product) => product.vesa))].sort((a, b) =>
          a.localeCompare(b, undefined, { numeric: true })
        );
        vesaOptions.replaceChildren(...values.map((value) => this.createOption('vesa', value, value)));
      }
      const weights = products.map((product) => product.weight).filter((value) => value > 0);
      const weightMin = weights.length ? Math.min(...weights) : 0;
      const weightMax = Math.max(this.dataset.collectionHandle === 'supports-muraux' ? 120 : 0, ...weights);
      for (const input of this.querySelectorAll('[data-norden-weight-input="min"], [data-norden-weight-range="min"]')) {
        input.min = String(weightMin);
        input.max = String(weightMax);
        if (input.type === 'range') input.value = String(weightMin);
      }
      for (const input of this.querySelectorAll('[data-norden-weight-input="max"], [data-norden-weight-range="max"]')) {
        input.min = String(weightMin);
        input.max = String(weightMax);
        if (input.type === 'range') input.value = String(weightMax);
      }
      this.querySelectorAll('[data-norden-weight-input="min"]').forEach((input) => {
        input.placeholder = String(weightMin);
      });
      this.querySelectorAll('[data-norden-weight-input="max"]').forEach((input) => {
        input.placeholder = String(weightMax);
      });
    }

    updateWeightTracks() {
      for (const track of this.querySelectorAll('[data-norden-double-range="weight"]')) {
        const min = track.querySelector('[data-norden-weight-range="min"]');
        const max = track.querySelector('[data-norden-weight-range="max"]');
        if (!min || !max) continue;
        const lower = Number(min.min);
        const upper = Number(max.max);
        const span = upper - lower || 1;
        track.style.setProperty('--norden-range-start', `${((Number(min.value) - lower) / span) * 100}%`);
        track.style.setProperty('--norden-range-end', `${((Number(max.value) - lower) / span) * 100}%`);
      }
    }

    createOption(group, value, labelText) {
      const label = document.createElement('label');
      label.className = 'norden-filter-option';
      const main = document.createElement('span');
      main.className = 'norden-filter-option__main';
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.name = `norden_${group}`;
      checkbox.value = value;
      checkbox.dataset[`norden${group.charAt(0).toUpperCase()}${group.slice(1)}`] = '';
      const labelTextNode = document.createElement('span');
      labelTextNode.textContent = labelText;
      const count = document.createElement('span');
      count.className = 'norden-filter-option__count';
      count.dataset.nordenCount = `${group}:${value}`;
      main.append(checkbox, labelTextNode);
      label.append(main, count);
      return label;
    }

    inDiagonalBucket(product, bucket) {
      return product.tvMin > 0 && product.tvMax >= bucket.min && product.tvMin <= bucket.max;
    }

    restoreFromURL() {
      const params = new URLSearchParams(window.location.search);
      for (const name of ['norden_diagonal', 'norden_vesa', 'norden_type']) {
        const selected = new Set(params.getAll(name).flatMap((value) => value.split(',')).map((value) => value.trim().toLowerCase()));
        this.form.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
          input.checked = selected.has(input.value.toLowerCase());
        });
      }
      for (const name of ['norden_weight_min', 'norden_weight_max']) {
        const input = this.form.querySelector(`input[name="${name}"]`);
        if (input) input.value = params.get(name) || '';
      }
      const weightMin = this.form.querySelector('[data-norden-weight-input="min"]');
      const weightMax = this.form.querySelector('[data-norden-weight-input="max"]');
      if (weightMin) {
        const range = this.form.querySelector('[data-norden-weight-range="min"]');
        if (range && weightMin.value) range.value = weightMin.value;
      }
      if (weightMax) {
        const range = this.form.querySelector('[data-norden-weight-range="max"]');
        if (range && weightMax.value) range.value = weightMax.value;
      }
    }

    state() {
      const data = new FormData(this.form);
      const numeric = (name) => {
        const value = String(data.get(name) || '').trim().replace(',', '.');
        return value === '' ? null : Number(value);
      };
      return {
        diagonal: data.getAll('norden_diagonal'),
        type: data.getAll('norden_type'),
        vesa: data.getAll('norden_vesa').map((value) => String(value).toLowerCase()),
        weightMin: numeric('norden_weight_min'),
        weightMax: numeric('norden_weight_max'),
        priceMin: numeric('filter.v.price.gte'),
        priceMax: numeric('filter.v.price.lte'),
      };
    }

    productMatches(product, state, omittedGroup = '') {
      if (omittedGroup !== 'type' && state.type.length && !state.type.some((value) => product.types.includes(value))) return false;
      if (omittedGroup !== 'price') {
        const min = state.priceMin === null ? Number.NEGATIVE_INFINITY : Math.round(state.priceMin * 100);
        const max = state.priceMax === null ? Number.POSITIVE_INFINITY : Math.round(state.priceMax * 100);
        if (product.priceMax < min || product.priceMin > max) return false;
      }
      if (omittedGroup !== 'diagonal' && state.diagonal.length) {
        const selected = state.diagonal.map((value) => nordenDiagonalBuckets.find((bucket) => bucket.value === value)).filter(Boolean);
        if (!selected.some((bucket) => this.inDiagonalBucket(product, bucket))) return false;
      }
      if (omittedGroup !== 'vesa' && state.vesa.length && !state.vesa.some((value) => product.vesa.includes(value))) return false;
      if (omittedGroup !== 'weight') {
        if (state.weightMin !== null && product.weight < state.weightMin) return false;
        if (state.weightMax !== null && product.weight > state.weightMax) return false;
      }
      return true;
    }

    applyFilters() {
      if (!this.form || !this.isConnected) return;
      const products = this.products;
      const state = this.state();
      let visibleCount = 0;
      for (const product of products) {
        const visible = this.productMatches(product, state);
        product.card.hidden = !visible;
        if (visible) visibleCount += 1;
      }
      this.updateCounts(products, state);
      this.updateResultStatus(visibleCount);
      this.updateActiveFilterCount(state);
      this.updateEmptyState(visibleCount);
    }

    updateCounts(products, state) {
      const candidates = this.querySelectorAll('[data-norden-count]');
      candidates.forEach((node) => {
        const [group, value] = node.dataset.nordenCount.split(':');
        let count = 0;
        for (const product of products) {
          if (!this.productMatches(product, state, group)) continue;
          if (group === 'diagonal') {
            const bucket = nordenDiagonalBuckets.find((item) => item.value === value);
            if (bucket && this.inDiagonalBucket(product, bucket)) count += 1;
          } else if (group === 'vesa' && product.vesa.includes(value)) {
            count += 1;
          } else if (group === 'type' && product.types.includes(value)) {
            count += 1;
          }
        }
        node.textContent = String(count);
      });
    }

    updateResultStatus(count) {
      const template = this.dataset.resultTemplate || 'COUNT products';
      const label = template.replace('COUNT', new Intl.NumberFormat(document.documentElement.lang || 'fr-FR').format(count));
      this.section.querySelectorAll('[data-testid="products-count"] [role="status"]').forEach((node) => {
        node.textContent = label;
      });
      const applyLabel = this.section.querySelector('[data-norden-apply-count]');
      if (applyLabel) applyLabel.textContent = label;
    }

    updateActiveFilterCount(state) {
      const active = state.diagonal.length + state.vesa.length + state.type.length + Number(state.weightMin !== null || state.weightMax !== null) + Number(state.priceMin !== null || state.priceMax !== null);
      const bubble = this.section.querySelector('#filter-count-bubble-toggle');
      if (!bubble) return;
      bubble.hidden = active === 0;
      const text = bubble.querySelector('.filter-count-bubble__text');
      if (text) text.textContent = String(active);
      bubble.setAttribute('aria-label', (this.dataset.activeCountTemplate || 'Active filters: COUNT').replace('COUNT', String(active)));
      this.section.querySelectorAll('.facets__bubble').forEach((node) => {
        node.textContent = String(active);
        node.hidden = active === 0;
      });
    }

    updateEmptyState(count) {
      const grid = this.section.querySelector('[data-testid="product-grid"]');
      if (!grid) return;
      let empty = this.section.querySelector('[data-norden-empty]');
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'norden-filter-empty';
        empty.dataset.nordenEmpty = '';
        empty.setAttribute('role', 'status');
        empty.textContent = this.dataset.emptyMessage || '';
        grid.parentElement?.append(empty);
      }
      empty.hidden = count > 0;
    }

    handleInput(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.matches('[data-norden-weight-range="min"]')) {
        const max = this.form.querySelector('[data-norden-weight-range="max"]');
        if (max && Number(target.value) > Number(max.value)) max.value = target.value;
        this.syncWeightFields();
      } else if (target.matches('[data-norden-weight-range="max"]')) {
        const min = this.form.querySelector('[data-norden-weight-range="min"]');
        if (min && Number(target.value) < Number(min.value)) min.value = target.value;
        this.syncWeightFields();
      } else if (target.matches('[data-norden-weight-input]')) {
        this.syncWeightSliders(target);
      } else {
        return;
      }
      this.applyFilters();
      this.updateWeightTracks();
    }

    handleChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.matches('[data-norden-diagonal], [data-norden-vesa], [data-norden-type], [data-norden-weight-input], [data-norden-weight-range]')) return;
      if (target.matches('[data-norden-weight-input]')) this.syncWeightSliders(target, true);
      this.applyFilters();
      this.updateWeightTracks();
      if (!this.closest('dialog')) this.formComponent.updateFilters();
    }

    syncWeightFields() {
      const min = this.form.querySelector('[data-norden-weight-range="min"]');
      const max = this.form.querySelector('[data-norden-weight-range="max"]');
      const minInput = this.form.querySelector('[data-norden-weight-input="min"]');
      const maxInput = this.form.querySelector('[data-norden-weight-input="max"]');
      if (minInput && min) minInput.value = min.value === min.min ? '' : min.value;
      if (maxInput && max) maxInput.value = max.value === max.max ? '' : max.value;
    }

    syncWeightSliders(changedInput, commit = false) {
      const minInput = this.form.querySelector('[data-norden-weight-input="min"]');
      const maxInput = this.form.querySelector('[data-norden-weight-input="max"]');
      const minRange = this.form.querySelector('[data-norden-weight-range="min"]');
      const maxRange = this.form.querySelector('[data-norden-weight-range="max"]');
      if (!minInput || !maxInput || !minRange || !maxRange) return;
      if (changedInput === minInput && minInput.value) {
        const value = Math.max(Number(minRange.min), Math.min(Number(minRange.max), Number(minInput.value)));
        minRange.value = String(Math.min(value, Number(maxRange.value)));
        if (commit) minInput.value = Number(minRange.value) === Number(minRange.min) ? '' : minRange.value;
      } else if (changedInput === minInput) {
        minRange.value = minRange.min;
      }
      if (changedInput === maxInput && maxInput.value) {
        const value = Math.max(Number(maxRange.min), Math.min(Number(maxRange.max), Number(maxInput.value)));
        maxRange.value = String(Math.max(value, Number(minRange.value)));
        if (commit) maxInput.value = Number(maxRange.value) === Number(maxRange.max) ? '' : maxRange.value;
      } else if (changedInput === maxInput) {
        maxRange.value = maxRange.max;
      }
    }

    handleAction(event) {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (target.closest('[data-norden-reset]')) {
        const actionDialog = target.closest('dialog');
        if (!this.contains(target) && actionDialog !== this.closest('dialog')) return;
        event.preventDefault();
        this.section.querySelectorAll('input[name="norden_diagonal"], input[name="norden_vesa"], input[name="norden_type"], input[name="norden_weight_min"], input[name="norden_weight_max"]').forEach((input) => {
          if (input.type === 'checkbox') input.checked = false;
          else input.value = '';
        });
        this.section.querySelectorAll('[data-norden-weight-range="min"]').forEach((input) => input.value = input.min);
        this.section.querySelectorAll('[data-norden-weight-range="max"]').forEach((input) => input.value = input.max);
        this.section.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach((input) => input.value = '');
        this.section.querySelectorAll('[data-norden-price-slider="min"]').forEach((input) => input.value = input.min);
        this.section.querySelectorAll('[data-norden-price-slider="max"]').forEach((input) => input.value = input.max);
        this.formComponent.updateFilters();
      } else if (target.closest('[data-norden-apply]')) {
        if (target.closest('dialog') !== this.closest('dialog')) return;
        event.preventDefault();
        this.formComponent.updateFilters();
      }
    }
  }

  if (!customElements.get('norden-collection-filter-groups')) {
    customElements.define('norden-collection-filter-groups', NordenCollectionFilterGroups);
  }

  class NordenPriceRange extends HTMLElement {
    connectedCallback() {
      this.minRange = this.querySelector('[data-norden-price-slider="min"]');
      this.maxRange = this.querySelector('[data-norden-price-slider="max"]');
      this.priceFacet = this.closest('price-facet-component');
      this.minInput = this.priceFacet?.querySelector('[ref="minInput"]');
      this.maxInput = this.priceFacet?.querySelector('[ref="maxInput"]');
      if (!this.minRange || !this.maxRange || !this.minInput || !this.maxInput) return;
      this.handleInput = this.handleInput.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.addEventListener('input', this.handleInput);
      this.addEventListener('change', this.handleChange);
      this.handlePriceInput = this.handlePriceInput.bind(this);
      this.priceFacet.addEventListener('input', this.handlePriceInput);
      this.syncFromFields();
    }

    disconnectedCallback() {
      this.removeEventListener('input', this.handleInput);
      this.removeEventListener('change', this.handleChange);
      this.priceFacet?.removeEventListener('input', this.handlePriceInput);
    }

    syncFromFields(updateFields = true) {
      if (!this.minRange || !this.maxRange) return;
      const parse = (value) => {
        if (String(value || '').trim() === '') return null;
        const number = Number(String(value || '').replace(',', '.'));
        return Number.isFinite(number) ? number : null;
      };
      const lower = Number(this.minRange.min);
      const upper = Number(this.maxRange.max);
      const enteredMin = parse(this.minInput.value);
      const enteredMax = parse(this.maxInput.value);
      const selectedMin = Math.max(lower, Math.min(upper, enteredMin ?? lower));
      const selectedMax = Math.max(lower, Math.min(upper, enteredMax ?? upper));
      this.minRange.value = String(Math.min(selectedMin, selectedMax));
      this.maxRange.value = String(Math.max(selectedMin, selectedMax));
      if (updateFields && enteredMin !== null) this.minInput.value = Number(this.minRange.value) === lower ? '' : Number(this.minRange.value).toFixed(2);
      if (updateFields && enteredMax !== null) this.maxInput.value = Number(this.maxRange.value) === upper ? '' : Number(this.maxRange.value).toFixed(2);
      this.updateTrack();
    }

    handleInput(event) {
      const input = event.target;
      if (input === this.minRange && Number(this.minRange.value) > Number(this.maxRange.value)) this.maxRange.value = this.minRange.value;
      if (input === this.maxRange && Number(this.maxRange.value) < Number(this.minRange.value)) this.minRange.value = this.maxRange.value;
      this.minInput.value = Number(this.minRange.value) <= Number(this.minRange.min) ? '' : this.minRange.value;
      this.maxInput.value = Number(this.maxRange.value) >= Number(this.maxRange.max) ? '' : this.maxRange.value;
      this.updateTrack();
      this.priceFacet?.closest('facets-form-component')?.querySelector('norden-collection-filter-groups')?.applyFilters();
    }

    handleChange() {
      if (this.closest('dialog')) return;
      if (this.priceFacet?.hasAttribute('on:change')) return;
      this.priceFacet?.updatePriceFilterAndResults();
    }

    handlePriceInput(event) {
      if (event.target !== this.minInput && event.target !== this.maxInput) return;
      this.syncFromFields(false);
      this.priceFacet?.closest('facets-form-component')?.querySelector('norden-collection-filter-groups')?.applyFilters();
    }

    updateTrack() {
      const lower = Number(this.minRange.min);
      const upper = Number(this.maxRange.max);
      const span = upper - lower || 1;
      const track = this.querySelector('.norden-double-range');
      track?.style.setProperty('--norden-range-start', `${((Number(this.minRange.value) - lower) / span) * 100}%`);
      track?.style.setProperty('--norden-range-end', `${((Number(this.maxRange.value) - lower) / span) * 100}%`);
    }
  }

  if (!customElements.get('norden-price-range')) {
    customElements.define('norden-price-range', NordenPriceRange);
  }
  } catch(e) { console.error(e); }
})();

})();
